export const getTitleForDataPointModal = (openDataName) => {
  switch (openDataName) {
    case "firstTimeBuyer":
      return "Edit Previous Homeowner";
    case "street":
    case "city":
    case "county":
    case "state":
      return "Edit Address";
    case "occupancyType":
      return "Edit Occupancy";
    case "propertyType":
      return "Edit Property Type";
    case "isUsCitizen":
      return "Edit Citizenry";
    case "isVeteran":
      return "Edit Veteran Status";
    case "isSelfEmployed":
      return "Edit Self Employed Status";
    case "hasRealEstateAgent":
      return "Edit Real Estate Agent";
    case "isBuyingAsIs":
      return "Edit Buying As-Is";
    case "forSaleByOwner":
      return "Edit For Sale By Owner";
    case "hasTitleCompany":
      return "Edit Title Company";
    case "hasWaivedEscrow":
      return "Edit Has Waived Escrow";
    case "price":
      return "Edit Property Value";
    case "existingLoanBalance":
      return "Edit Existing Loan Balance";
    case "takeCashOut":
    case "amountOfCashOut":
      return "Edit Take Cash Out";
    case "disabledVeteran":
      return "Edit Disability Status";
    case "vaFirstTimeUse":
      return "Edit VA Loan History";
    case "lookAtVaLoans":
      return "Edit VA Loan View";
    case "downPayment":
      return "Edit Down Payment";
    case "creditScore":
      return "Edit Credit Score";
    case "plannedClosingDate":
      return "Edit Planned Closing Date";
    case "loanOptions":
      return "Edit Loan Options";
    default:
      return null;
  }
};
